<template>
    <div class="body">
        <transition appear>
          <div v-if="!reportData" class="zhezhao">
              <div class="image" style="width: 100%; height: 13%">
                <!-- <img src="@/assets/logo1.png" style="width: 217px; height: 77px; margin-left: 7px"/> -->
              </div>

              <div class="right" style="width: 100%; height: 87%">
                <p class="font1" style="font-size: 86px; margin-top: 20vh;color: #70b787;"> 2024富学宝典</p>
                <p class="font1" style=" color: #99345d;font-size: 71px;margin-top: 20px;color: #36854f;"> 四月学习报告 </p>
                <p class="font1" style="font-size: 41px;margin-top: 27px;color: #70b787;"> 坚持学习的人永葆青春 </p>
               
                <div v-show="!Loading" class="input-container" style="margin-top: 4vh">
                  <input v-model="jobNo" type="text" id="input" required="" />
                  <label for="input" class="label">请输入工号</label>
                  <div class="underline"></div>
                </div>
                <div v-show="!Loading" style="display: flex; justify-content: center;margin-top:40px;">
                  <button class="button" @click="inputJobNo()">NEXT</button>
                </div>
                <!-- <LoadingAuguest v-show="Loading" style="margin-top: 30vh" /> -->
              </div>
          </div>
        </transition>
        <main v-if="reportData && reportData.studate != 0" id="main" ref="scrollDiv" class="view">
          <section id="section01" class="section">
              <!-- 有学习天数，有学分 -->
              <div v-if="reportData.studate > 0 && reportData.creditvalue > 0" style="display: flex; flex-wrap: wrap">
                <div class="left" style="width: 100%; margin-top: 10vh">
                  <p class="font1" style="font-size: 30px; margin-top: 21px;">Hi～<span class="font2" style="font-size: 36px;">{{ reportData.stuname }}</span>，我们又见面啦</p>
                  <p class="font1" style="font-size: 30px; margin-top: 15px;"><span class="font2" style="font-size: 36px;">2024</span>年<span class="font2" style="font-size: 36px;">4</span>月</p>

                  <p class="font1" style="font-size: 30px;margin-top: 15px;">你已经学习了<span class="font2" style="font-size: 32px;">{{ reportData.studate }}</span>天</p>
                  <p class="font1"  v-if="reportData.playtime !==null" style="font-size: 30px;margin-top: 15px;">累计学习了<span class="font2" style="font-size: 32px;">{{ reportData.playtime }}</span >小时</p>

                  <p class="font1" v-if="reportData.coursenumMon !==null" style="font-size: 30px;margin-top: 15px;">学习了<span class="font2" style="font-size: 32px;">{{ reportData.coursenumMon }}</span >门课程</p>
                  <p class="font1" v-if="reportData.coursenum !==null" style="font-size: 36px;text-align: center;margin-top: 45px;">完成了<span class="font2" style="font-size: 32px;">{{ reportData.coursenum }}</span >门课程</p>

                  <p class="font1" v-if="reportData.examTimes !==null" style="font-size: 30px;margin-top: 15px;">累计考试<span class="font2" style="font-size: 32px;">{{ reportData.examTimes }}</span >次</p>
                  <p class="font1" v-if="reportData.creditvalue !==null" style="font-size: 36px;text-align: center;margin-top: 45px;">获得学分<span class="font2" style="font-size: 32px;">{{ reportData.creditvalue }}</span >分</p>
                </div>
              </div>

              <!-- 有学习天数，没有学分 -->
              <div v-if="reportData.studate > 0 && !reportData.creditvalue" style="display: flex; flex-wrap: wrap">
                <div class="left" style="width: 100%; margin-top: 10vh">
                  <p class="font1" style="font-size: 30px; margin-top: 21px;">Hi～<span class="font2" style="font-size: 36px;">{{ reportData.stuname }}</span>，我们又见面啦</p>
                  <p class="font1" style="font-size: 30px; margin-top: 15px;"><span class="font2" style="font-size: 36px;">2024</span>年<span class="font2" style="font-size: 36px;">4</span>月</p>

                  <p class="font1" style="font-size: 30px;margin-top: 15px;">你在富学宝典平台上的总学习天数达到了<span class="font2" style="font-size: 32px;">{{ reportData.studate }}</span >天</p>
                  <p class="font1" style="font-size: 30px;margin-top: 15px;">但是还没有获得学分，请继续加油！</p>
                  <p class="font2" style="font-size: 36px;text-align: center;margin-top: 45px;">{{ reportData.textLab.text }}</p>
                </div>
              </div>

               <!-- 没有学习天数，没有学分 -->
              <div v-if="!reportData.studate && !reportData.creditvalue" style="display: flex; flex-wrap: wrap">
                <div class="left" style="width: 100%; margin-top: 20vh">
                  <p class="font1" style="font-size: 30px; margin-top: 21px;">Hi～<span class="font2" style="font-size: 36px;">{{ reportData.stuname }}</span>，我们又见面啦</p>
                  <p class="font1" style="font-size: 30px; margin-top: 15px;"><span class="font2" style="font-size: 36px;">2024</span>年<span class="font2" style="font-size: 36px;">4</span>月</p>

                  <p class="font1" style="font-size: 30px;margin-top: 15px;">你还没有在富学宝典上学习，请继续加油！</p>
                  <p class="font2" style="font-size: 36px;text-align: center;margin-top: 45px;">{{ reportData.textLab.text }}</p>
                </div>
              </div>
          </section>


          <section id="section02" class="section">
              <div class="page2" style="display: flex; flex-wrap: wrap">
                <div class="right" style="width: 100%; margin-top: 10vh">
                  <p class="font2" style="font-size: 30px; margin-top: 21px;text-align: center;">勤学如春起之苗</p>
                  <p class="font2" style="font-size: 30px; margin-top: 21px;text-align: center;">不见其增，日有所长。</p>

                  <p  style="text-align: center;font-weight: 700;color: black; font-size: 30px;margin-top: 21px;">2023年富学宝典上热门课程推荐：</p>
                  <div v-for="(item,index) in mergeBook.slice(0,3)" :key="index" style="width: 100%;margin: 0 auto;text-align: center;margin-top: 2vh;font-size: 30px;color: #000;">
                     <p @click="redirectToBook(index)" class="font1" style="margin-top: 1vh;">{{item.Name}}&nbsp;&nbsp;<i class="fa fa-arrow-right fa-lg" style="color:#36854f;"></i></p>
                  </div>

                  <p  v-if="uncompletedLink !==null"  style="text-align: center;font-weight: 700;color: #000; font-size: 30px;margin-top: 21px;">以下课程已学习过半，您离完成目标只差一步之遥：</p>
                  <div  v-for="(item,index) in mergeBook.slice(3)" :key="index+3" style="width: 100%;margin: 0 auto;text-align: center;margin-top: 2vh;font-size: 30px;color: #000;">
                     <p @click="redirectToBook(index+3)" class="font1" style="margin-top: 1vh;">{{item.Name}}&nbsp;&nbsp;<i class="fa fa-arrow-right fa-lg" style="color:#36854f;"></i></p>
                  </div>
                </div>
              </div>
          </section>

          <section id="section03" class="section">
              <div style="display: flex; flex-wrap: wrap">
                <div class="right" style="width: 100%; margin-top: 10vh">
                  <p class="font2" style="font-size: 30px; margin-top: 21px;text-align: center;">勤耕岁月学无涯，</p>
                  <p class="font2" style="font-size: 30px; margin-top: 21px;text-align: center;">积学成才道路赊。</p>
                  <!-- <div>
                    <p class="font1" style="margin: 0 auto; font-size: 30px;color: #000;text-align: center;margin-top: 3vh;">2024年必修课程：</p>
                    <ul style="margin: 0 auto; font-size: 30px;color: #000;;text-align: center;margin-top: 3vh;">
                      <li>{{ coc[0].Name }}&nbsp;&nbsp;<span class="font3" v-if="coc[0].iscompleted===true">已完成</span><span class="font3" v-else>未完成</span></li>
                      <li>{{ coc[1].Name }}&nbsp;&nbsp;<span class="font3" v-if="coc[1].iscompleted===true">已完成</span><span class="font3" v-else>未完成</span></li>
                    </ul>
                    <p style="width: 100%;margin: 0 auto;font-size: 15px;color: #000;margin-top: 3vh;text-align: center;">**具体可登录富学宝典查看:【首页】>【个人设置】>【学习任务】**</p>
                  </div> -->
                  <div>
                    <p class="font1" style="margin: 0 auto; font-size: 30px;color: #000;text-align: center;margin-top: 3vh;">EHS+ESG 4月主题课程推荐：</p>
                    <ul style="margin: 0 auto; font-size: 30px;color: #000;;text-align: center;margin-top: 3vh;">
                      <a href="https://iedu.foxconn.com/public/play/playCourse?courseId=34060" style="text-decoration: none;color: #000;"><li>{{ themeLink.Name }}</li></a>
                    </ul>
                  </div>
                </div>
              </div>
          </section>

          <section id="section04" class="section">
              <div class="page4"  style="display: flex; flex-wrap: wrap">
                <div class="title"><p class="font1" style="font-size: 60px;">好书推荐</p></div>
                    <div class="left" style="margin-top: 40px;width: 80%;margin: 0 auto;">
                        <div class="detail">
                            <p style="text-align: center;font-size: 30px;color: #000;">《创新之力》</p>
                            <p class="font2" style="font-size: 18px;text-align: center;">[英]Matt Kingdon(马特金登)</p>
                        </div>
                        <div class="bookDetail" style="font-size: 17px;padding: 20px;color: #000;">
                            <span style="font-size: 20px;">
                              《创新之力——将创意变为现实》是关于组织创新者激活创新精神的终极操作指南！讲述了大企业中平凡英雄们的创新故事。本书深入挖掘如何才能使创新在那些运行思维模式已根深蒂固的公司里真正实现。<br><br>
                               本书包含一系列的观察，探讨人们在组织中如何做出努力以将看似毫无关联的东西融会贯通，努力推进，从而实现创新。更重要的是，书中也提供了实用的步骤教你如何获得“好运气”来发现工作中的下一个“新大陆”。<br><br>
                            </span>
                        </div>
                    </div>
                    <div class="right" style="margin-top: 40px;width: 80%;margin: 0 auto;">
                        <div class="detail">
                          <p style="text-align: center;font-size: 30px;color: #000;">《创新的天梯》</p>
                          <p class="font2" style="font-size: 18px;text-align: center;">[以]亚里拉登伯格(Arie Ruttenberg)<br>[加]夏罗默迈特尔(Shlomo Maital)</p>
                        
                        </div>
                        <div class="bookDetail" style="font-size: 17px;padding: 20px;">
                          <span style="font-size: 20px;text-align: justify;color:#000;">
                            这是一本故事书，却全面地解答了创新研究领域最难的问题“How to do”。<br><br>  
                            “创新不是技术，是艺术”，技术有界，艺术无边；技术是有明确规则和边界的一系列标准规范，而每一次创新都是打破现有标准规范的一场革命。推拉推创新方法能让每一个人，在理性标准的三步之内，身在凡世，思维无疆；打破边界，实现创新。<br><br>  
                            神奇吗？读完本书，你会觉得，下一个创新，已经离你不远……<br><br> 
                          </span>
                        </div>
                    </div>         
              </div>
          </section>

          <section id="section05" class="section">
              <div class="page5" style="position: relative;top: 10vh;">
                    <div style="margin: 0 auto;margin-top: 10vh">
                        <p class="font1" style="font-size: 30px; text-align: center;">你希望在富学宝典平台上遇见哪些好课程呢?</p>
                        <p class="font1"  style="font-size: 28px;text-align: center;margin-top: 2vh;">请写下你的学习清单吧！</p>
                        <form id="form" class="topBefore">
                            <textarea id="message" v-model="comment" type="text" placeholder="MESSAGE"></textarea>
                            <input id="submit"  @click="submit" type="button" value="OK!" />
                        </form>
                    </div>
                    <div style="padding-top: 70px;margin: 0 auto;">
                        <p style="font-size: 48px;text-align: center;color: #000;">THANK YOU!</p>
                        <p class="font1" style="font-size: 48px;text-align: center;">一旦决心学习，谁也拦不住你</p>
                    </div>
              </div>
          </section>
        </main>
    </div>
</template>

<script>
import Loading from './Loading.vue'
import viewApi from "@/api/view";
import dataApi from "@/api/data";
import { getArray } from "../../utils/encourage";
export default {
    data(){
      return{
        viewId: "",
        Loading:false,
        reportData:'',
        jobNo:'',
        comment: "",
        source: "",

        recommendBook:'',
        uncompletedLink:'',
        mergeBook:'',
        coc:'',
        themeLink:''
      }
    },
    created(){
      document.title = "四月学习报告";
      /* 相信数据begin */
      var test = window.location.href
      let arr = test.split("?code=")
      this.code = arr[1]
      if (this.code) {
        viewApi.getJobNoByBelieve(this.code).then((res) => {
          if(res.data.code === 200) {
            this.jobNo = res.data.data.jobNo
            this.source = "相信"
            if (this.jobNo) {
              this.Loading = true;
              this.getData()
            }
          }
        })
      }
      /* 相信数据end */
    },
    methods:{
      submit() {
      if (!this.comment) {
        this.$message({
          message: "请说说您的学习计划",
          type: "warning",
          center: true,
        });
      } else if (this.comment) {
        const view = {
          comment: this.comment,
          studyList: this.studyList,
        };
        view["id"] = this.viewId;
        console.log(view);
        viewApi.update(view).then((res) => {
          if (res) {
            this.$message({
              message: "提交成功，感谢您的留言。",
              type: "success",
              center: true,
            });
          }
        });
      }
      },
      inputJobNo() {
            if (this.Loading === true) {
              return;
            }
            if (this.jobNo) {
              this.Loading = true;
              this.getData();
            } else {
              this.$message({
                message: "请输入工号",
                type: "warning",
                center: true,
              });
            }
      },
      getData() {
            dataApi.getDataFor24April(this.jobNo).then((res) => {
              this.reportData = res.data.data.data;
              // console.log(res.data.data.data);

              this.recommendBook=JSON.parse(this.reportData.topRecommendLink)
              this.uncompletedLink=JSON.parse(this.reportData.uncompletedLink)
              this.mergeBook=this.recommendBook.concat(this.uncompletedLink)
              // this.coc=JSON.parse(this.reportData.coc)
              this.themeLink=JSON.parse(this.reportData.themeLink)
              if (this.reportData) {
                this.sendViewRecords();
                // this.Loading = false;
                this.reportData.textLab = getArray(this.reportData.textLab);
              } else if (!this.reportData) {
                this.$message({
                  message: "抱歉，暂时找不到您的学习报告！",
                  type: "warning",
                  center: true,
                });
                this.Loading = false;
              }
            });
      },
      sendViewRecords() {
          if (this.jobNo) {
            let viewData = {
              jobNo: this.jobNo,
              device: "PC",
              type: 17,
              browser: this.browser,
            };
            if (this.source) {
              viewData["source"] = this.source;
            }
            viewApi.view(viewData).then((res) => {
              this.viewId = res.data.data.data.id;
            });
          } else {
            return;
          }
      },
      redirectToBook(id){
        const book=this.mergeBook[id]
        const view={
            clickCourseName:book.Name,
            clickCourseLink:book.link
        }
        view["id"] = this.viewId;
        viewApi.update(view).then((res) => {
          if (res.data.code===200) {
            window.location.href = view.clickCourseLink;
          }
        });
      }
    },
    mounted(){
     
    }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
/* 字体样式 */
.font1{
  color:rgb(36, 35, 35); 
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  font-weight: 700; 
  text-align: center;
}
.font2{
  color: #36854f; 
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  font-weight: 700; 
}

.font3{
  color: #70b787; 
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  text-align: center;
}
/* 第一页 */
.body {
  width: 100vw;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
}

.zhezhao {
  width: 100vw;
  height: 100vh;
  /* background-image: linear-gradient(170deg, #b55d7f , #953b5d); */
  background:url("../../assets/24April/pbg.jpg")  no-repeat;
  background-size: 100% 100%,cover;
  position: absolute;
  display: flex;
  flex-wrap: wrap;
}
.input-container {
  position: relative;
  margin: 50px auto;
  width: 400px;
}

.input-container input[type="text"] {
  font-size: 20px;
  width: 100%;
  border: none;
  border-bottom: 2px solid #000;
  padding: 5px 0;
  background-color: transparent;
  outline: none;
  color: #36854f;
}

.input-container .label {
  position: absolute;
  top: 0;
  left: 0;
  color: #000;
  transition: all 0.3s ease;
  pointer-events: none;
}

.input-container input[type="text"]:focus ~ .label,
.input-container input[type="text"]:valid ~ .label {
  top: -20px;
  font-size: 16px;
  color: #36854f;
}

.input-container .underline {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  width: 100%;
  background-color: #36854f;
  transform: scaleX(0);
  transition: all 0.3s ease;
}

.input-container input[type="text"]:focus ~ .underline,
.input-container input[type="text"]:valid ~ .underline {
  transform: scaleX(1);
}
.button {
  --bg: #94d8a9;
  --text-color: #fff;
  position: relative;
  width: 150px;
  height: 40px;
  border: none;
  background: var(--bg);
  color: var(--text-color);
  padding: 1em;
  font-weight: bold;
  text-transform: uppercase;
  transition: 0.2s;
  border-radius: 5px;
  opacity: 0.8;
  letter-spacing: 1px;
  box-shadow: #8fb39b 0px 7px 2px, #000 0px 8px 5px;
}

.button:hover {
  opacity: 1;
}

.button:active {
  top: 4px;
  box-shadow: #75bc8c 0px 3px 2px, #000 0px 3px 5px;
}

/* 第二页 */
.view {
  width: 100%;
  height: 100%;
  background:url("../../assets/24April/pbg.jpg")  no-repeat;
  background-size: 100% 100%,cover;
  /* background-image: linear-gradient(170deg, #7a94ac , #a2bed8); */
}
main {
  scroll-snap-type: y mandatory;
  scroll-padding: 80px;
  overflow: scroll;
  height: 100vh;
}
section {
  width: 100vw;
  height: 100vh;
  scroll-snap-align: start;
}
#section01,#section02,#section03,#section04{
  position: relative;
}
ul{
    list-style-type: none;
    padding: 0;
    color: #fff;
    text-align: center;
}
li {
    align-items: center;
    margin-bottom: 8px; 
}

/* li::before {
    content: '\2022'; 
    color: #fff;
    font-size: 1.5em;
    margin-right: 3px; 
    margin: 0 auto;
} */

/*书籍推荐页 */
.title {
  font-size: 50px;
  width: 100%;
  margin-bottom: 30px;
  margin-top: 30px;
}


/* 最后的输入框 */
#form {
  position: relative;
  width: 40vw;
  padding-top: 50px;
  margin: 0 auto;
}

input {
  font-family: "Lato", sans-serif;
  font-size: 0.875em;
  width: 570px;
  height: 50px;
  padding: 0px 15px 0px 15px;
  background: transparent;
  outline: none;
  color: #000;
  border: solid 1px #fff;
  border-bottom: none;
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
}

input:hover {
  background: #fff;
  color: #000;
}

textarea {
  width: 40vw;
  max-width: 40vw;
  height: 20vh;
  max-height: 20vh;
  padding: 0;
  background: transparent;
  outline: none;
  color: #000;
  font-family: "Lato", sans-serif;
  font-size: 0.875em;
  border: solid 1px #36854f;
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
}

/* textarea:hover {
  background: #e89fbb;
  color: #fff;
} */

#submit {
  width:  40vw;
  padding: 0;
  margin: -5px 0px 0px 0px;
  font-family: "Lato", sans-serif;
  font-size: 0.875em;
  color: #000;
  outline: none;
  cursor: pointer;
  border: solid 1px #36854f;
  border-top: none;
}

#submit:hover {
  color: #b3aca7;
}
/* 

*/
</style>